import { render } from "./ProfileStatsRating.vue?vue&type=template&id=366ea63d&scoped=true"
import script from "./ProfileStatsRating.vue?vue&type=script&lang=js"
export * from "./ProfileStatsRating.vue?vue&type=script&lang=js"

import "./ProfileStatsRating.vue?vue&type=style&index=0&id=366ea63d&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-366ea63d"]])

export default __exports__